import React from 'react';
import { useStyles } from './ErrorMessageWithIcon.style';
import ErrorIcon from '@material-ui/icons/Error';

interface IProps {
  message: string;
  size?: string;
  customIcon?: React.ReactElement;
}

const ErrorMessageWithIcon: React.FC<IProps> = (props) => {
  const classes = useStyles(props);
  const { message, customIcon } = props;

  return (
    <div className={classes.wrapper}>
      {customIcon ? customIcon : <ErrorIcon className={classes.icon} />}
      <p className={classes.message}>{message}</p>
    </div>
  );
};

export default ErrorMessageWithIcon;
